module.exports = __webpack_public_path__ + "img/charts.8bcc8d11.svg";